import React, { useState, useEffect } from "react";
import {
  Form, Button, Card, Row, Col, Table, Modal, Alert, InputGroup,
} from "react-bootstrap";
import Header from "../Components/Header";

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showEditSuccess, setShowEditSuccess] = useState(false);
  const [showEditError, setShowEditError] = useState(false);
  const [showError, setShowError] = useState(false);
  const [activeOption, setActiveOption] = useState("create");
  const [busqueda, setBusqueda] = useState("");
  const [resultados, setResultados] = useState([]);
  const [buscado, setBuscado] = useState(false);
  const [formData, setFormData] = useState({
    Identificacion: "",
    Num_Identificacion: "",
    Nombre: "",
    Apellidos: "",
    DenominacionSocial: "",
    Email: "",
    Telefono: "",
    Direccion: "",
    Contraseña: "",
    Rol: "usuario",
  });

  const emptyForm = {
    Identificacion: "",
    Num_Identificacion: "",
    Nombre: "",
    Apellidos: "",
    DenominacionSocial: "",
    Email: "",
    Telefono: "",
    Direccion: "",
    Contraseña: "",
    Rol: "usuario",
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    try {
      const response = await fetch("https://sectorb12.info/api/usuarios", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.ok) {
        const data = await response.json();
        setUsuarios(data);
      }
    } catch (error) {
      console.error(error);
      setShowError(true);
    }
  };

  const handleBuscar = (e) => {
    e.preventDefault();
    const term = busqueda.trim().toUpperCase();
    const filtrados = usuarios.filter((u) =>
      u.Num_Identificacion?.toUpperCase().includes(term)
    );
    setResultados(filtrados);
    setBuscado(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://sectorb12.info/api/usuarios", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setShowSuccess(true);
        fetchUsuarios();
        setFormData(emptyForm);
      } else {
        throw new Error();
      }
    } catch {
      setShowError(true);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://sectorb12.info/api/usuarios/${selectedUsuario.UsuarioID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(formData),
        }
      );
      if (response.ok) {
        fetchUsuarios();
        setShowEditSuccess(true);
        setSelectedUsuario(null);
        setFormData(emptyForm);
        // Actualizar resultados de búsqueda
        const term = busqueda.trim().toUpperCase();
        const filtrados = (await (await fetch("https://sectorb12.info/api/usuarios", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })).json()).filter((u) => u.Num_Identificacion?.toUpperCase().includes(term));
        setResultados(filtrados);
      } else {
        throw new Error();
      }
    } catch {
      setShowEditError(true);
    }
  };

  const handleEdit = (usuario) => {
    setSelectedUsuario(usuario);
    setFormData({ ...usuario, Contraseña: "" });
  };

  const handleDelete = (usuarioId) => {
    setShowModal(true);
    setSelectedUsuario(usuarioId);
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(
        `https://sectorb12.info/api/usuarios/${selectedUsuario}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      if (response.ok) {
        fetchUsuarios();
        setShowSuccess(true);
        setShowModal(false);
        setResultados((prev) => prev.filter((u) => u.UsuarioID !== selectedUsuario));
      }
    } catch {
      setShowError(true);
      setShowModal(false);
    }
  };

  const renderFormFields = () => (
    <>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Tipo de identificación</Form.Label>
            <Form.Select name="Identificacion" value={formData.Identificacion} onChange={handleChange} required>
              <option value="">Seleccione...</option>
              <option value="dni">DNI</option>
              <option value="nie">NIE</option>
              <option value="cif">CIF</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={8}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Número de identificación</Form.Label>
            <Form.Control type="text" name="Num_Identificacion" value={formData.Num_Identificacion} onChange={handleChange} placeholder="Ej: 12345678A" required />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Nombre</Form.Label>
            <Form.Control type="text" name="Nombre" value={formData.Nombre} onChange={handleChange} required />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Apellidos</Form.Label>
            <Form.Control type="text" name="Apellidos" value={formData.Apellidos} onChange={handleChange} required />
          </Form.Group>
        </Col>
      </Row>
      <Form.Group className="mb-3">
        <Form.Label className="small fw-semibold">Denominación Social</Form.Label>
        <Form.Control type="text" name="DenominacionSocial" value={formData.DenominacionSocial} onChange={handleChange} />
      </Form.Group>
      <Row>
        <Col md={7}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Email</Form.Label>
            <Form.Control type="email" name="Email" value={formData.Email} onChange={handleChange} required />
          </Form.Group>
        </Col>
        <Col md={5}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Teléfono</Form.Label>
            <Form.Control type="text" name="Telefono" value={formData.Telefono} onChange={handleChange} required />
          </Form.Group>
        </Col>
      </Row>
      <Form.Group className="mb-3">
        <Form.Label className="small fw-semibold">Dirección</Form.Label>
        <Form.Control type="text" name="Direccion" value={formData.Direccion} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label className="small fw-semibold">Contraseña</Form.Label>
        <Form.Control type="password" name="Contraseña" value={formData.Contraseña} onChange={handleChange} placeholder={selectedUsuario ? "Dejar vacío para no cambiar" : ""} required={!selectedUsuario} />
      </Form.Group>
      <input type="hidden" name="Rol" value="usuario" />
    </>
  );

  return (
    <div>
      <Row className="d-flex flex-column">
        <Header />
        <Col md={12} className="mx-auto px-4">

          {/* Toggle */}
          <Card className="shadow-sm mb-4 border-0" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title><strong>Gestión de Usuarios</strong></Card.Title>
              <p className="text-muted mb-3">Seleccione una opción:</p>
              <Row>
                <Col>
                  <Button
                    variant={activeOption === "create" ? "success" : "outline-success"}
                    className="w-100"
                    onClick={() => { setActiveOption("create"); setFormData(emptyForm); setSelectedUsuario(null); }}
                  >
                    <i className="bi bi-person-plus me-2"></i>Crear Usuario
                  </Button>
                </Col>
                <Col>
                  <Button
                    variant={activeOption === "edit" ? "success" : "outline-success"}
                    className="w-100"
                    onClick={() => { setActiveOption("edit"); setSelectedUsuario(null); setBuscado(false); setBusqueda(""); }}
                  >
                    <i className="bi bi-pencil me-2"></i>Editar / Eliminar
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Alertas */}
          {showSuccess && <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>Operación realizada con éxito.</Alert>}
          {showError && <Alert variant="danger" onClose={() => setShowError(false)} dismissible>Ocurrió un error al procesar la solicitud.</Alert>}
          {showEditSuccess && <Alert variant="success" onClose={() => setShowEditSuccess(false)} dismissible>Usuario editado con éxito.</Alert>}
          {showEditError && <Alert variant="danger" onClose={() => setShowEditError(false)} dismissible>Ocurrió un error al actualizar el usuario.</Alert>}

          {/* Crear */}
          {activeOption === "create" && (
            <Card className="shadow-sm mb-4 border-0" style={{ borderRadius: "0.75rem" }}>
              <Card.Body className="p-4">
                <Card.Title className="mb-4">Nuevo usuario</Card.Title>
                <Form onSubmit={handleCreateSubmit}>
                  {renderFormFields()}
                  <Button variant="success" type="submit" className="mt-2 w-100">
                    <i className="bi bi-check-lg me-2"></i>Crear Usuario
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          )}

          {/* Editar / Eliminar */}
          {activeOption === "edit" && (
            <Card className="shadow-sm mb-4 border-0" style={{ borderRadius: "0.75rem" }}>
              <Card.Body className="p-4">
                <Card.Title className="mb-3">Buscar Usuario</Card.Title>
                <Form onSubmit={handleBuscar}>
                  <InputGroup className="mb-3">
                    <Form.Control
                      placeholder="Buscar por DNI / NIE / CIF"
                      value={busqueda}
                      onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <Button variant="success" type="submit">
                      <i className="bi bi-search"></i> Buscar
                    </Button>
                    {busqueda && (
                      <Button variant="outline-secondary" onClick={() => { setBusqueda(""); setResultados([]); setBuscado(false); setSelectedUsuario(null); }}>
                        ✕
                      </Button>
                    )}
                  </InputGroup>
                </Form>

                {buscado && resultados.length === 0 && (
                  <p className="text-muted">No se encontraron usuarios con esa identificación.</p>
                )}

                {resultados.length > 0 && (
                  <Table hover responsive className="align-middle mt-2">
                    <thead className="table-light">
                      <tr>
                        <th>Nombre</th>
                        <th>Apellidos</th>
                        <th>Email</th>
                        <th>Identificación</th>
                        <th className="text-center">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resultados.map((usuario) => (
                        <tr key={usuario.UsuarioID} className={selectedUsuario?.UsuarioID === usuario.UsuarioID ? "table-success" : ""}>
                          <td>{usuario.Nombre}</td>
                          <td>{usuario.Apellidos}</td>
                          <td>{usuario.Email}</td>
                          <td>{usuario.Num_Identificacion}</td>
                          <td className="text-center">
                            <Button variant="outline-warning" size="sm" className="me-2" onClick={() => handleEdit(usuario)}>
                              <i className="bi bi-pencil"></i>
                            </Button>
                            <Button variant="outline-danger" size="sm" onClick={() => handleDelete(usuario.UsuarioID)}>
                              <i className="bi bi-trash"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}

                {selectedUsuario && typeof selectedUsuario === "object" && (
                  <div className="mt-4">
                    <p className="fw-semibold text-muted border-bottom pb-2">
                      Editando: {selectedUsuario.Nombre} {selectedUsuario.Apellidos}
                    </p>
                    <Form onSubmit={handleEditSubmit}>
                      {renderFormFields()}
                      <Button variant="success" type="submit" className="mt-2">
                        <i className="bi bi-check-lg me-2"></i>Guardar Cambios
                      </Button>
                    </Form>
                  </div>
                )}
              </Card.Body>
            </Card>
          )}

          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Confirmar Eliminación</Modal.Title>
            </Modal.Header>
            <Modal.Body>¿Estás seguro de que quieres eliminar este usuario?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
              <Button variant="danger" onClick={confirmDelete}>Eliminar</Button>
            </Modal.Footer>
          </Modal>

        </Col>
      </Row>
    </div>
  );
};

export default Usuarios;